import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "24", "height": "24", "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M9.80191 15.8643L10.5 16.8692L11.1981 15.8643L12.9321 13.3682C15.5742 13.5876 17.65 15.8016 17.65 18.5003V21.0003C17.65 21.0831 17.5828 21.1503 17.5 21.1503H3.5C3.41716 21.1503 3.35 21.0831 3.35 21.0003V18.5003C3.35 15.8016 5.42584 13.5876 8.06792 13.3682L9.80191 15.8643ZM14.15 6.55078C14.15 8.56662 12.5158 10.2008 10.5 10.2008C8.48416 10.2008 6.85 8.56662 6.85 6.55078C6.85 4.53494 8.48416 2.90078 10.5 2.90078C12.5158 2.90078 14.15 4.53494 14.15 6.55078Z", "stroke": "currentColor", "stroke-width": "1.7" } }), _c("path", { staticStyle: { "fill": "var(--active-color-2)", "fill-opacity": "1" }, attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M18.65 10.15V7.5H20.35V10.15H23V11.85H20.35V14.5H18.65V11.85H16V10.15H18.65Z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const InviteIcon = __component__.exports;
export {
  InviteIcon as default
};
